package com.ervasstudio.tracoemovimento.pages.cursos.signup

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.ervasstudio.tracoemovimento.model.Aluno
import com.ervasstudio.tracoemovimento.model.EtapasDeCadastro
import com.ervasstudio.tracoemovimento.model.Paginas
import com.ervasstudio.tracoemovimento.repository.AuthRepository
import com.ervasstudio.tracoemovimento.repository.BlogRepository.checkEmailAlunoExists
import com.ervasstudio.tracoemovimento.repository.BlogRepository.getAlunoByEmail
import com.ervasstudio.tracoemovimento.repository.BlogRepository.sendNewAluno
import com.ervasstudio.tracoemovimento.util.rememberIsMobile
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.browser.window
import kotlinx.coroutines.launch


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun Signup() {

    val isMobile = rememberIsMobile()
    val ctx = rememberPageContext()
    val coroutineScope = rememberCoroutineScope()
    val authState by AuthRepository.state.collectAsState()
    val scope = rememberCoroutineScope()
    var thisnome by remember { mutableStateOf("") }
    var thissobrenome by remember { mutableStateOf("") }
    var thisemail by remember { mutableStateOf("") }
    var thisSenha by remember { mutableStateOf("") }
    var thisRepeticaoSenha by remember { mutableStateOf("") }
    var apiErrorMessage by remember { mutableStateOf<String?>(null) }
    var errorMessage by remember { mutableStateOf<String?>(null) }
    var etapa by remember { mutableStateOf(EtapasDeCadastro.PrimeitaEtapa) }

    val auth = Firebase.auth

    val localStorageKey = "aluno"
    val localStorageKeyNome = "nomeAluno"

    SignUpPage(
        jaTenhoContaClick = { ctx.router.navigateTo(Paginas.LOGIN.rota) },
        onContinuarClicked = {
            coroutineScope.launch {

                apiErrorMessage = null
                val emailExists = checkEmailAlunoExists(thisemail)

                if (emailExists) {
                    apiErrorMessage = "Este e-mail já se encontra cadastrado."
                } else {
                    etapa = EtapasDeCadastro.SegundaEtapa

                }
            }
        },
        nome = thisnome,
        sobrenome = thissobrenome,
        email = thisemail,
        onNomeChange = { thisnome = it },
        onSobrenomeChange = { thissobrenome = it },
        onEmailChange = { thisemail = it },
        externalError = apiErrorMessage,
        etapa = etapa,
        senha = thisSenha,
        repeticaoSenha = thisRepeticaoSenha,
        onSenhaChange = { thisSenha = it },
        onRepeticaoSenhaChange = { thisRepeticaoSenha = it },
        isMobile = isMobile,
        onCadastrarClick = {

            coroutineScope.launch {
                try {
                    val result = auth.createUserWithEmailAndPassword(thisemail, thisSenha)
                    println("Conta criada com sucesso: ${result.user?.uid}")
                    // Ex: ctx.router.navigateTo("/onboarding")

                    try {
                        val novoAluno = Aluno(
                            nome = thisnome,
                            sobrenome = thissobrenome,
                            email = result.user?.email,
                            celular = "0",
                            sexo = "",
                            nascimento = "",
                            id_autor = "",
                            dataCriacao = "",
                            dataModificacao = "",
                            slug = "",
                            id = "",
                            status = "",
                        )
                        val alunoGravadoJetengine = sendNewAluno(aluno = novoAluno)
                        if (alunoGravadoJetengine) {
                            result.user?.email?.let { window.localStorage.setItem(localStorageKey, it) }
                            window.localStorage.setItem(localStorageKeyNome, thisnome)
                            ctx.router.navigateTo(Paginas.`MEUS CURSOS`.rota)
                        }

                    } catch (e: Exception) {
                        errorMessage = e.message
                    }

                } catch (e: Exception) {
                    errorMessage = e.message
                }
            }
        },
        errorMessage = errorMessage,
        onGoogleLoginButtonClick = {
            coroutineScope.launch {
                try {
                    val aluno = getAlunoByEmail(it.email!!)

                    if (aluno != null) {
                        it.email.let { window.localStorage.setItem(localStorageKey, it) }
                        it.displayName?.let { value -> window.localStorage.setItem(localStorageKeyNome, value) }
                        ctx.router.navigateTo(Paginas.`MEUS CURSOS`.rota)
                    } else {
                        val partesNome = it.displayName?.trim()?.split("\\s+".toRegex(), limit = 2)
                        val primeiroNome = partesNome?.getOrNull(0) ?: ""
                        val sobrenome = partesNome?.getOrNull(1) ?: ""


                        val novoAluno = Aluno(
                            nome = primeiroNome,
                            sobrenome = sobrenome,
                            email = it.email,
                            celular = "0",
                            sexo = "",
                            nascimento = "",
                            id_autor = "",
                            dataCriacao = "",
                            dataModificacao = "",
                            slug = "",
                            id = "",
                            status = "",
                        )
                        val alunoGravadoJetengine = sendNewAluno(aluno = novoAluno)
                        if (alunoGravadoJetengine) {
                            it.email.let { window.localStorage.setItem(localStorageKey, it) }
                            it.displayName?.let { value -> window.localStorage.setItem(localStorageKeyNome, value) }
                            ctx.router.navigateTo(Paginas.`MEUS CURSOS`.rota)
                        }
                    }
                } catch (e: Exception) {

                }
            }
        },
    )
}